import { useCallback, useState } from "react";
import { RefreshControl, StyleSheet } from "react-native";

import { palette } from "@stepapp/ui";

export const useRefreshControl = (callback: () => Promise<NotWorth>) => {
  const [refreshing, setRefreshing] = useState(false);

  const handleRefresh = useCallback(async () => {
    setRefreshing(true);
    try {
      await callback();
    } finally {
      setRefreshing(false);
    }
  }, [callback]);

  return [
    () => (
      <RefreshControl
        colors={[palette.primary.accent]}
        onRefresh={handleRefresh}
        refreshing={refreshing}
        style={styles.refreshControl}
        tintColor={palette.primary.accent}
      />
    ),
    refreshing,
  ] as const;
};

const styles = StyleSheet.create({
  refreshControl: {
    elevation: 2,
    zIndex: 2,
  },
});
